import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/absence-requests'
const RESOURCE_NAME_REQUESTS = '/request-types'
export default {
  requestTypes() {
    return axios.get(`${config.webApiBase + RESOURCE_NAME_REQUESTS}`)
  },
  edit(id, absence) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}`, absence)
  },
  approve(id, absence) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}/approve`, absence)
  },
  create(absence) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, absence)
  },
  createdirect(absence) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/store-direct`, absence)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  uploadDocument(id, formData) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/${id}/upload-document`, formData)
  },
  deleteDocument(id, fileId) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME}/${id}/documents/${fileId}`)
  },
  getAbsence(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  // eslint-disable-next-line camelcase
  list(page, per_page, user_id, type_id, date_ini, date_fin, status, client_id = '', department_id = '', include_team = false) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/list`, {
      page,
      per_page,
      user_id,
      type_id,
      start_date: date_ini,
      end_date: date_fin,
      status,
      client_id,
      department_id,
      include_team,
    })
  },
}
